import * as base from "../lib/PageBase";
import { IdToken } from "../constants/GlobalConstants";
import { getStorage } from "../lib/LocalStorageService";

export const _getOrderHistory = (data = {}) => {

	return fetch(base.baseUrlOrderHistory, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, *cors, same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		headers: {
			'Content-Type': 'application/json',
			'X-TECHNICIAN': getStorage(IdToken)
		},
		redirect: 'follow', // manual, *follow, error
		referrer: 'no-referrer', // no-referrer, *client
		body: JSON.stringify(data) // body data type must match "Content-Type" header
	}).then(res => res.json());
}
